import { Star } from "lucide-react";
import { useReviews } from "@/hooks/useSiteContent";

const FALLBACK = [
  { author: "Tamika H.", rating: 5, text: "Great service!! Great food!!! Seasoned to perfection!" },
];

export const Testimonials = () => {
  const items = useReviews();
  const list = items && items.length ? items : FALLBACK;

  return (
    <section id="reviews" data-testid="reviews-section" className="bg-[#0A0A0A] py-20 md:py-28 border-t border-[#222]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 max-w-3xl">
          <div className="text-xs uppercase tracking-widest text-[#E60000] font-bold mb-3">Word On The Block</div>
          <h2 className="font-heading text-5xl sm:text-6xl text-white">
            Real Talk from <span className="text-[#E60000]">Real Customers</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {list.map((r, i) => (
            <article
              key={r.id || i}
              data-testid={`review-${i}`}
              className="bg-[#1A1A1A] border border-[#333] p-6 md:p-7 hover:border-[#E60000] transition-colors group"
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: Math.max(1, Math.min(5, r.rating || 5)) }).map((_, j) => (
                  <Star key={j} className="w-5 h-5 fill-[#E60000] text-[#E60000]" strokeWidth={0} />
                ))}
              </div>
              <p className="text-white/80 leading-relaxed text-base mb-6 italic">"{r.text}"</p>
              <div className="font-heading text-xl text-white tracking-wide border-t border-[#333] pt-4">
                — {r.author || r.name}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
